export const isInIframe = () => window.location !== window.parent.location;
